import React, { useState, useContext } from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import Swal from 'sweetalert2';

import authContext from "../../context/authentication/authContex";
import { getNewFormattedDate } from "../../utils/funciones";

import './StateChangeOPD.css';

const STATES_OPD = ['PENDIENTE', 'ENPROCESO', 'FINALIZADA'];

const StateChangeOPD = ({ opd, guardarEstado, cerrar }) => {
    const { globalSettings } = useContext(authContext);

    const [selectedState, setSelectedState] = useState(opd.state || 'PENDIENTE');
    const [fechaCompletado, setFechaCompletado] = useState(opd.fechaCompletado || getNewFormattedDate());
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const toggle = () => setDropdownOpen((prevState) => !prevState);

    const getStateLabel = (state) => {
        switch (state) {
            case 'PENDIENTE': return 'PENDIENTE';
            case 'ENPROCESO': return 'EN PROCESO';
            case 'FINALIZADA': return 'FINALIZADA';
            default: return state;
        }
    };

    const handleChange = (newState) => {
        setSelectedState(newState);
        if (newState === 'FINALIZADA') {
            setFechaCompletado(getNewFormattedDate());
        }
    };

    const handleChangeFecha = (value) => {
        setFechaCompletado(getNewFormattedDate(value));
    };

    const handleSave = async () => {
        if (selectedState === opd.state) {
            cerrar();
            return;
        }

        setLoading(true);
        try {
            const updates = { state: selectedState };
            if (selectedState === 'FINALIZADA') {
                updates.fechaCompletado = fechaCompletado;
            }

            await guardarEstado(opd._id, updates, []);
            Swal.fire({
                title: `Nuevo Estado: ${getStateLabel(selectedState)}`,
                text: 'El Estado fue Modificado Correctamente',
                icon: 'success'
            });
            cerrar();
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: 'No se pudo modificar el estado',
                icon: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-gr-state-opd">
            <button className="minimizarBtn label-state-icon-r" onClick={() => cerrar()}>X</button>
            <div className="container-state-opd">
                <div className="label-state-data-opd">
                    {'OPD - ' + opd.tDocNroFor + ' . Estado Actual: ' + getStateLabel(opd.state)}
                </div>
                <div className="container-state-list-opd">
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down" className="dropdown-userTypes">
                        <DropdownToggle caret>
                            {getStateLabel(selectedState)}
                        </DropdownToggle>
                        <DropdownMenu>
                            {STATES_OPD.map((state) => (
                                <DropdownItem key={state} onClick={() => handleChange(state)}>
                                    {getStateLabel(state)}
                                </DropdownItem>
                            ))}
                        </DropdownMenu>
                    </Dropdown>
                    {selectedState === 'FINALIZADA' && (
                        <div className="inputGroup">
                            <label>Fecha Completado</label>
                            <input
                                disabled={!globalSettings?.allowChooseEndDateODT}
                                className="fechaCompletadoInput"
                                type="datetime-local"
                                onChange={(e) => handleChangeFecha(e.target.value)}
                                value={fechaCompletado}
                                name="fechaCompletado"
                            />
                        </div>
                    )}
                </div>
                <div className="btn-state-container-opd">
                    <button
                        disabled={loading}
                        className={`btn-state-opd ${loading ? 'disabled' : ''}`}
                        onClick={handleSave}
                    >
                        Cambiar Estado
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StateChangeOPD;
